// マイページ開設済表示
import React, { useEffect } from 'react';
import { render } from 'react-dom';
import Block from '../../molecules/Block';
import Annotation from '../../atoms/Annotation';
import CenterButton from '../../atoms/CenterButton';
import { handleBrowserBack } from '../../BrowserBack';

const MypageOpened: React.FC = () => {
  useEffect(() => {
    // ブラウザの戻る・進む禁止
    handleBrowserBack();
  }, []);
  // ボタン押下時の処理
  const transitionLogin = () => {
    location.replace(`${process.env.MIX_MOCK_URL}/mypage/login/redirect`);
  };

  return (
    <Block
      label={'マイページ開設済'}
      content={
        <>
          <Annotation
            text={
              'お送りいただいたメールアドレスでマイページは開設済です。ログイン画面からお手続きを進めて下さい。'
            }
          />
          <div className="content-box">
            <CenterButton
              btn_class={'arrow-right'}
              label={'ログイン画面へ'}
              handleClick={transitionLogin}
            />
          </div>
        </>
      }
    />
  );
};

if (document.getElementById('mypage-opened')) {
  render(<MypageOpened />, document.getElementById('mypage-opened'));
}
